<template>
  <div
    v-if="showWrap"
    :class="showContent ? 'fadein' : 'fadeout'"
    class="toestBody high-level"
  >
    <div class="toest">
      <mu-icon
        v-if="type == 'success'"
        size="56"
        value="check_circle"
        color="success"
      ></mu-icon>
      <mu-icon
        v-if="type == 'warning'"
        size="56"
        value="priority_high"
        color="warning"
      ></mu-icon>
      <mu-icon
        v-if="type == 'info'"
        size="56"
        value="info"
        color="info"
      ></mu-icon>
      <mu-icon
        v-if="type == 'error'"
        size="56"
        value="warning"
        color="error"
      ></mu-icon>
      <div>{{ text }}</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {},
  data() {
    return {
      // text: "这是个提示"
    }
  },
}
</script>
<style lang="scss" scoped>
.toestBody {
  // height: 100%;
  // width: 100%;
  position: absolute;
}
.toest {
  background-color: rgba(0, 0, 0, 0.6);
  color: #fff;
  padding: 15px 15px;
  border-radius: 5px;
  text-align: center;
  position: fixed;
  left: 50%;
  top: 50%;
  width: 40%;
  font-size: 15px;
  transform: translate(-50%, -50%);
}
.fadein {
  animation: animate_in 0.25s;
}
.fadeout {
  animation: animate_out 0.25s;
  opacity: 0;
}
@keyframes animate_in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes animate_out {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
</style>
